import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 4D43349E-EF13-4BB1-9684-0CEDE55DE9DE
 * name arrow-top-left-bold-outline
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-top-left-bold-outline.svg
 * tags
 * - Arrow 
 */
export const ArrowTopLeftBoldOutlineIcon = createSvgIcon(<><path d="M14.12,8.46L19.78,14.12L14.12,19.78L8.46,14.12L4.22,18.36V4.22H18.36L14.12,8.46M6.34,13.41L8.46,11.29L14.12,16.95L16.95,14.12L11.29,8.47L13.41,6.34H6.34V13.41Z" /></>, 'ArrowTopLeftBoldOutlineIcon');
export default ArrowTopLeftBoldOutlineIcon